
import { Link } from 'react-router-dom';
import logoSvg from '@/assets/images/logo.svg';

const Logo = () => {
  return (
    <Link to="/" className="flex items-center">
      <img 
        src={logoSvg} 
        alt="Commercial Property LK Logo" 
        className="h-10 w-auto" 
      />
    </Link>
  );
};

export default Logo;
